'use client'
import * as React from 'react'

type Props = React.SVGProps<SVGSVGElement> & {
  /** czas trwania fali (opcjonalnie) */
  shineDurationMs?: number
}

export const CheckmarkIcon = ({
  className,
  shineDurationMs,
  ...props
}: Props) => {
  // useId potrafi zwrócić ":" – usuwamy dla pełnej zgodności z url(#id)
  const uid = React.useId().replace(/:/g, '')
  const maskId = `cutout-${uid}`
  const shineId = `shine-${uid}`
  const cutoutW = 10

  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 100 100"
        className={`icon ${className ?? ''}`}
        {...props}
        style={{
          ...(props.style || {}),
          // możesz też nadpisać wprost: style={{ '--shine-duration':'3s' } as React.CSSProperties}
          ['--shine-duration' as any]: `${shineDurationMs ?? 2800}ms`,
        }}
      >
        <defs>
          {/* Maska: białe = widoczne (koło), czarne = wycięcie (check) */}
          <mask id={maskId}>
            <rect width="100%" height="100%" fill="black" />
            <circle cx="50" cy="50" r="35" fill="white" />
            <polyline
              points="34.673,45.626 44.401,55.354 65.327,34.428"
              fill="none"
              stroke="black"
              strokeWidth={cutoutW}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </mask>

          {/* wąska fala rozjaśnienia (diagonalnie) */}
          <linearGradient id={shineId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="45%" stopColor="#ffffff" stopOpacity="0" />
            <stop offset="50%" stopColor="#ffffff" stopOpacity="0.65" />
            <stop offset="55%" stopColor="#ffffff" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* pełne tło w kolorze, check jako przezroczyste wycięcie */}
        <rect
          width="100%"
          height="100%"
          fill="currentColor"
          mask={`url(#${maskId})`}
        />

        {/* shimmer: fala jaśniejszego koloru od top-left do bottom-right */}
        <g mask={`url(#${maskId})`} className="shine">
          <rect
            className="shineRect"
            x="-150"
            y="-150"
            width="300"
            height="300"
            fill={`url(#${shineId})`}
          />
        </g>
      </svg>

      <style jsx>{`
        .icon {
          display: inline-block;
          vertical-align: middle;
          color: #f57606; /* bazowy kolor */
        }

        .shine {
          pointer-events: none;
        }

        .shineRect {
          animation: shimmer var(--shine-duration) infinite;
          animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        }

        @keyframes shimmer {
          0% {
            transform: translate(-150px, -150px);
          }
          100% {
            transform: translate(150px, 150px);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .shineRect {
            animation: none;
          }
        }
      `}</style>
    </>
  )
}
